import { env } from '../../../env';
import { AdminConsoleUser } from './admin-console-types';

// memberOf arriva come stringa per un solo gruppo e come lista per più gruppi
export const toSamlGroups = (memberOf: unknown): string[] =>
  (Array.isArray(memberOf) ? memberOf : [memberOf]).filter(
    (group): group is string => typeof group === 'string'
  );

export const belongsToGroup = (
  groups: string[] | undefined,
  group: string
): boolean =>
  !!group &&
  !!groups?.some(
    (userGroup) => userGroup.toLowerCase() === group.toLowerCase()
  );

// Only for the UI: the backend has to check the group on the fiduciarie APIs as well.
export const canManageFiduciarie = (user?: AdminConsoleUser | null): boolean =>
  belongsToGroup(user?.groups, env.adminConsoleFiduciarieMemberOfGroup);
